import script from "./PdfsProviderDocuments.vue?vue&type=script&setup=true&lang=ts"
export * from "./PdfsProviderDocuments.vue?vue&type=script&setup=true&lang=ts"

import "./PdfsProviderDocuments.vue?vue&type=style&index=0&id=229ecf72&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-229ecf72"]])

export default __exports__